export enum PendingValidationPostsListFilter {
    TO_VALIDATE = 'to_validate',
    URGENT = 'urgent',
    REMARKS = 'remarks',
}
